export default {
  resetFloorState: (state) => {
    state.floor_id = null;
    state.name = null;
    state.planURL = null;
    state.fileName = null;
    state.fileSize = null;
  },
  setFloorData: (state, floor) => {
    state.floor_id = floor.floor_id;
    state.name = floor.name;
    state.planURL = floor.plan_url;
  },
  updateFloorName: (state, name) => (state.name = name || null),
  updatePlanURL: (state, { url, name, size }) => {
    state.planURL = url;
    state.fileName = name;
    state.fileSize = size;
  },
};
